import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";
import { map, filter } from "rxjs/operators";
import { EntryState, RootState, getLeague, LoadLeagueOnceAction, entryAvailable } from "@play/state";
import { Store } from "@ngrx/store";
import { League } from "@play/api-typings";
import { isTeam } from "@play/utility/league";

@Component({
    selector: "league-header",
    templateUrl: "./league-header.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueHeaderComponent implements OnChanges {
    public league$: Observable<EntryState<League>>;

    @Input() public leagueId: number;

    @Input() public leagueInfo;

    @Input() public skillLevel: string;

    public isTeamLeague$: Observable<boolean>;

    constructor(private store: Store<RootState>) {}

    public ngOnChanges(): void {
        if (!this.leagueId) {
            return;
        }

        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.isTeamLeague$ = this.league$.pipe(
            filter(entryAvailable),
            map(league => isTeam(league.entry))
        );
    }

    public leagueStateLevel(state: string) {
        switch (state) {
            case "setup":
                return 0;
            case "preSignUp":
                return 1;
            case "signUp":
                return 2;
            case "checkIn":
                return 3;
            case "lateSignUp":
                return 4;
            case "postSignUp":
                return 5;
            case "inProgress":
                return 6;
            case "finished":
                return 7;
            default:
                return 0;
        }
    }
}
